/**
 * usePostLoginSync — React hook that runs platform-appropriate sync
 * after a successful login.
 *
 * - Desktop: registers device, pulls server state
 * - Web: pulls server state (no device registration needed)
 * - Mobile: requests push permission, registers device + token, pulls state
 *
 * Usage:
 *   const runPostLoginSync = usePostLoginSync();
 *   // After login completes:
 *   await runPostLoginSync();
 */
import { useCallback } from "react";
import { platformType } from "@platform";
import { desktopPostLoginSync } from "@service/desktop-sync";
import { mobilePostLoginSync } from "@service/mobile-sync";
import { pullAllOnLogin } from "@service/sync-handler";

export function usePostLoginSync() {
  return useCallback(async () => {
    switch (platformType) {
      case "desktop":
        await desktopPostLoginSync();
        break;
      case "mobile":
        await mobilePostLoginSync();
        break;
      case "web":
      default:
        await pullAllOnLogin();
        break;
    }
  }, []);
}
